import RefreshTokenInterface from '@/utilities/auth/azure/interfaces/RefreshTokenInterface'
import AxiosService from '@/utilities/service/AxiosService'
import AzurePluginInterface from '@/utilities/auth/azure/interfaces/AzurePluginInterface'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { VueJwtDecodeType } from 'vue-jwt-decode'
import TokenManagerInterface from '@/utilities/auth/azure/interfaces/TokenManagerInterface'

export default class ResponseWatcher implements RefreshTokenInterface {
  private readonly service: AzurePluginInterface
  private readonly tokenManager: TokenManagerInterface
  private readonly jwtDecode: VueJwtDecodeType

  constructor(service: AzurePluginInterface, tokenManager: TokenManagerInterface, jwtDecode: VueJwtDecodeType) {
    this.service = service
    this.tokenManager = tokenManager
    this.jwtDecode = jwtDecode
  }

  watch(httpService: AxiosService, success: (token: string, request?: AxiosRequestConfig) => void, error: () => void): void {
    let isRefreshing = false

    const keyWords: Array<string> = ['User does not exist', 'Signature verification failed']

    httpService.axios.interceptors.response.use(
      (response: AxiosResponse) => response,
      async (err: { config: AxiosRequestConfig; response: AxiosResponse }) => {
        const { config, response } = err

        if (keyWords.includes(response?.data?.message)) {
          return error()
        }

        if (response?.data?.message === 'Expired token' && !isRefreshing) {
          isRefreshing = true

          try {
            const { idToken } = await this.service.refreshToken()

            success(idToken, config)
            isRefreshing = false

            return httpService.axios.request(config)
          } catch (e) {
            error()
          }
        } else {
          return Promise.reject(err)
        }
      },
    )
  }
}
